import { render, staticRenderFns } from "./VotingTable.vue?vue&type=template&id=19942847&scoped=true"
import script from "./VotingTable.vue?vue&type=script&lang=js"
export * from "./VotingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19942847",
  null
  
)

export default component.exports